import { IStorage } from './storage.interface';

export class NullLocalStorage implements IStorage {
  setItem() {}

  removeItem() {}

  clear() {}

  getItem() {
    return undefined;
  }
}
